import React, { useState, useEffect } from 'react';
import "../css/admin.css";
import "../css/GCPillButton.css";
import OtherProfileForm from "./otherProfile.js";
import SingleEventForm from './SingleEvent.js';
import SingleLocationForm from "./singleLocation.js"
import { Chart } from "chart.js/auto";
import "../css/eventsList.css";
import {BASE_URL} from "../constants"

function AdminForm({user, setUser, onClose}) {

    const [activeTab, setActiveTab] = useState("home");

    const [userReports, setUserReports] = useState([]);
    const [eventReports, setEventReports] = useState([]);
    const [commentReports, setCommentReports] = useState([]);
    const [locationReports, setLocationReports] = useState([]);
    const [superuserRequests, setSuperuserRequests] = useState([]);
    const [pastEvents, setPastEvents] = useState([]);
    const [showComments, setShowComments] = useState({});

    const [otherProfileData, setOtherProfileData] = useState("");
    const [isOtherProfileVisible, setIsOtherProfileVisible] = useState("");

    const [numOfUserReports, setNumOfUserReports] = useState("");
    const [numOfEventReports, setNumOfEventReports] = useState("");
    const [numOfCommentReports, setNumOfCommentReports] = useState("");
    const [numOfLocationReports, setNumOfLocationReports] = useState("");
    const [numOfSuperuserRequests, setNumeOfSuperUserRequests] = useState("");

    const [eventData, setEventData] = useState("");
    const [isEventCardVisible, setIsEventCardVisible] = useState("");

    const [locationData, setLocationData] = useState("");
    const [isLocationCardVisible, setIsLocationCardVisible] = useState("");

    const [ageChartDataByEvent, setAgeChartDataByEvent] = useState(null);
    const [isAgeChartVisible, setIsAgeChartVisible] = useState(false);

    const [proficencyChartDataByEvent, setProficencyChartDataByEvent] = useState(null);
    const [isProficencyChartVisible, setIsProficencyChartVisible] = useState(false);

    const [postcodeByEvent, setPostcodeByEvent] = useState(null);
    const [isPostcodeVisible, setIsPostcodeVisible] = useState(false);

    const [labelByEvent, setLabelByEvent] = useState(null);
    const [isLabelVisible, setIsLabelVisible] = useState(false);

    const [points, setpoints] = useState([]);

    useEffect(() => {
        setActiveTab("home");
    }, []);

    useEffect(() => {
        if (activeTab === "home"){
            fetchUserReports();
            fetchEventReports();
            fetchCommentReports();
            fetchLocationReports();
            fetchSuperuserRequests();

            setNumOfUserReports(userReports.length)
            setNumOfEventReports(eventReports.length)
            setNumOfCommentReports(commentReports.length)
            setNumOfLocationReports(locationReports.length)
            setNumeOfSuperUserRequests(superuserRequests.length)

        }
    }, [activeTab, userReports.length, eventReports.length, commentReports.length, locationReports.length, superuserRequests.length])
    
    useEffect(() => {
        if (activeTab === "userReports") {
            fetchUserReports();
        }
    }, [activeTab]);

    useEffect(() => {
        if (activeTab === "superuserRequests") {
            fetchUserReports();
        }
    }, [activeTab]);

    useEffect(() => {
        if (activeTab === "eventReports") {
            fetchEventReports();
        }
    }, [activeTab]);

    useEffect(() => {
        if (activeTab === "commentReports") {
            fetchCommentReports();
        }
    }, [activeTab]);

    useEffect(() => {
        if (activeTab === "locationReports") {
            fetchLocationReports();
        }
    }, [activeTab]);

    useEffect(() => {
        if (activeTab === "pastEvents") {
            console.log("Past Events Data:", pastEvents);
            fetchPastEvents();
        }
    }, [activeTab]);
    
    useEffect(() => {
        if (activeTab === "userInsights") {
            gatherPoints();
        }
    
    }, [activeTab]);

    const gatherPoints = async () => {
        try {
            const response = await fetch(`${BASE_URL}/api/gather_points/`);
            if (response.ok) {
                const data = await response.json();
                setpoints(data);
            } else {
                console.error('Failed to fetch user reports');
            }
        } catch (error) {
            console.error('Error fetching user reports:', error);
        }
    };

    
    useEffect(() => {
        console.log(points);
      
        const pointsChartDataKeys = Object.keys(points);
        const pointsChartDataValues = Object.values(points);
      
        const canvasId = "scoreChart";
        const ctx = document.getElementById(canvasId)?.getContext("2d");
      
        if (ctx) {
          if (window.myBarChart) {
            window.myBarChart.destroy();
          }
      
          window.myBarChart = new Chart(ctx, {
            type: "bar",
            data: {
              labels: pointsChartDataKeys,
              datasets: [
                {
                  label: "Number of Users",
                  data: pointsChartDataValues,
                  backgroundColor: "rgba(75, 192, 192, 0.2)",
                  borderColor: "rgba(75, 192, 192, 1)",
                  borderWidth: 1,
                },
              ],
            },
            options: {
              responsive: true,
              scales: {
                x: {
                  beginAtZero: true,
                },
                y: {
                  beginAtZero: true,
                },
              },
            },
          });
        }
      }, [points]);
      
      

    const makeSuperuser = async (username, locationName) => {

        const response = await fetch(`/api/make_superuser/`, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
          body: JSON.stringify({ 
                "username": username,
                "location_name": locationName
           }),
        });
    }

    const toggleComments = (eventId) => {
        setShowComments((prevState) => ({
            ...prevState,
            [eventId]: !prevState[eventId],
        }));
    };

    const toggleAgeChartVisibility = () => {
        setIsAgeChartVisible((prev) => !prev);
    };

    const toggleProficencyChartVisibility = () => {
        setIsProficencyChartVisible((prev) => !prev);
    };

    const togglePostcodeVisibility = () => {
        setIsPostcodeVisible((prev) => !prev);
    };

    const toggleLabelVisibility = () => {
        setIsLabelVisible((prev) => !prev);
    };

    const deleteRecord = async (report_id, reportType) => {

        console.log("Report ID: ", report_id)
        console.log("report type:", reportType)

        const response = await fetch(`${BASE_URL}/api/delete_record/`, {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json',
            },
          body: JSON.stringify({ 
                "report_id": report_id,
                "report_type": reportType
           }),
        });

        if (response.ok){
            const result = await response.json();
            if (reportType === "user"){
                if (result.status === "success") {
                    fetchUserReports();
                } else {
                    console.error("Failed to delete record on the server side");
                }
            }
            else if (reportType === "event"){
                if (result.status === "success") {
                    fetchEventReports();
                } else {
                    console.error("Failed to delete record on the server side");
                }
            }
            else if (reportType === "comment"){
                if (result.status === "success") {
                    fetchCommentReports();
                } else {
                    console.error("Failed to delete record on the server side");
                }
            }
            else if (reportType === "location"){
                if (result.status === "success") {
                    fetchLocationReports();
                } else {
                    console.error("Failed to delete record on the server side");
                }
            }
            else if (reportType === "superuser"){
                if (result.status === "success") {
                    fetchSuperuserRequests();
                } else {
                    console.error("Failed to delete record on the server side");
                }
            }
        } else {
            console.error("Failed to delete record - HTTP request failed");
        }
    };

    const fetchProfileData = async (username) => {

        console.log("going to gather data: ", username);
      
        const response = await fetch(`${BASE_URL}/api/gather_profile_data/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ username }),
        });
        const data = await response.json();
        console.log(data);
        setOtherProfileData(data);
        setIsOtherProfileVisible(true);
        console.log("isOtherProfileVisible: ", isOtherProfileVisible);
      }

      const fetchEventData = async (id) => {

        const response = await fetch(`${BASE_URL}/api/gather_event_data/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({event_id: id}),
        });
        const data = await response.json();
        console.log("data: ", data)

        setEventData(data);
        setIsEventCardVisible(true);
        console.log("This is the eventData: ", eventData)
  
      }

      const fetchLocationData = async (id) => {

        const response = await fetch(`${BASE_URL}/api/gather_location_data/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({location_name: id}),
        });
        const data = await response.json();
        console.log("data: ", data)

        setLocationData(data);
        setIsLocationCardVisible(true);
  
      }

    const fetchUserReports = async () => {
        try {
            const response = await fetch(`${BASE_URL}/api/get_user_reports/`);
            if (response.ok) {
                const data = await response.json();
                setUserReports(data);
            } else {
                console.error('Failed to fetch user reports');
            }
        } catch (error) {
            console.error('Error fetching user reports:', error);
        }
    };

    const fetchSuperuserRequests = async () => {
        try {
            const response = await fetch(`${BASE_URL}/api/get_superuser_requests/`);
            if (response.ok) {
                const data = await response.json();
                setSuperuserRequests(data);
            } else {
                console.error('Failed to fetch user reports');
            }
        } catch (error) {
            console.error('Error fetching user reports:', error);
        }
    };

    const fetchEventReports = async () => {
        try {
            const response = await fetch(`${BASE_URL}/api/get_event_reports/`);
            if (response.ok) {
                const data = await response.json();
                setEventReports(data);
            } else {
                console.error('Failed to fetch event reports');
            }
        } catch (error) {
            console.error('Error fetching event reports:', error);
        }
    };

    const fetchLocationReports = async () => {
        try {
            const response = await fetch(`${BASE_URL}/api/get_location_reports/`);
            if (response.ok) {
                const data = await response.json();
                setLocationReports(data);
            } else {
                console.error('Failed to fetch event reports');
            }
        } catch (error) {
            console.error('Error fetching event reports:', error);
        }
    };

    const fetchPastEvents = async () => {
        try {
            const response = await fetch(`${BASE_URL}/api/get_past_events/`);
            if (response.ok) {
                const data = await response.json();
                setPastEvents(data);

                const ageChartData = {};
                data.forEach((event) => {
                    if (event.age && event.age.age_range && event.age.data) {
                        ageChartData[event.event_id] = event.age;
                    }
                });
                setAgeChartDataByEvent(ageChartData);
                console.log("Chart data by event:", ageChartData);

                const proficencyChartData = {};
                data.forEach((event) => {
                    if (event.proficency && event.proficency.proficency && event.proficency.data){
                        proficencyChartData[event.event_id] = event.proficency;
                    }
                });
                setProficencyChartDataByEvent(proficencyChartData);

                const postcodeData = {};
                data.forEach((event) => {
                    if( event.post && event.post.keys){
                        postcodeData[event.event_id] = event.post;
                    }
                });
                setPostcodeByEvent(postcodeData);

                const labelData = {};
                data.forEach((event) => {
                    if(event.label && event.label.keys){
                        labelData[event.event_id] = event.label;
                    }
                });
                setLabelByEvent(labelData);
            } else {
                console.error('Failed to fetch past events');
            }
        } catch (error) {
            console.error('Error fetching past events:', error);
        }
    };

    useEffect(() => {
        if(isAgeChartVisible){
            const ageRangeLabels = {
                0: "16 to 24",
                1: "25 to 34",
                2: "35 to 44",
                3: "45 to 54",
                4: "55 to 65",
                5: "65+",
                6: "Prefer Not to Say",
            };
        
            
            if (ageChartDataByEvent && typeof ageChartDataByEvent === "object") {
                Object.keys(ageChartDataByEvent).forEach((eventId) => {
                    const ageChartData = ageChartDataByEvent[eventId];
                    const canvasId = `ageRangeChart-${eventId}`;
                    const ctx = document.getElementById(canvasId)?.getContext("2d");
        
                    if (ctx && ageChartData) {
                        
                        const mappedLabels = ageChartData.age_range.map(
                            (range) => ageRangeLabels[range]
                        );
        
                        new Chart(ctx, {
                            type: "bar",
                            data: {
                                labels: mappedLabels,
                                datasets: [
                                    {
                                        label: "Number of Users",
                                        data: ageChartData.data,
                                        backgroundColor: "rgba(75, 192, 192, 0.2)",
                                        borderColor: "rgba(75, 192, 192, 1)",
                                        borderWidth: 1,
                                    },
                                ],
                            },
                            options: {
                                responsive: true,
                                scales: {
                                    x: {
                                        title: {
                                            display: true,
                                            text: "Age Range",
                                        },
                                    },
                                    y: {
                                        beginAtZero: true,
                                        ticks: {
                                            stepSize: 1,
                                            callback: function (value) {
                                                return Number.isInteger(value)
                                                    ? value
                                                    : null;
                                            },
                                        },
                                        title: {
                                            display: true,
                                            text: "Number of Users",
                                        },
                                    },
                                },
                            },
                        });
                    }
                });
            }
        }
    }, [isAgeChartVisible, ageChartDataByEvent]);

    useEffect(() => {
        if(isProficencyChartVisible){
            const proficencyLabels = {
                0: "noAbility",
                1: "Beginner",
                2: "Intermediate",
                3: "Advanced",
                4: "Fluent",
            };
        
            
            if (proficencyChartDataByEvent && typeof proficencyChartDataByEvent === "object") {
                Object.keys(proficencyChartDataByEvent).forEach((eventId) => {
                    const proficencyChartData = proficencyChartDataByEvent[eventId];
                    const canvasId = `proficencyRangeChart-${eventId}`;
                    const ctx = document.getElementById(canvasId)?.getContext("2d");
        
                    if (ctx && proficencyChartData) {
                        
                        const mappedLabels = proficencyChartData.proficency.map(
                            (range) => proficencyLabels[range]
                        );
        
                        new Chart(ctx, {
                            type: "bar",
                            data: {
                                labels: mappedLabels,
                                datasets: [
                                    {
                                        label: "Number of Users",
                                        data: proficencyChartData.data,
                                        backgroundColor: "rgba(75, 192, 192, 0.2)",
                                        borderColor: "rgba(75, 192, 192, 1)",
                                        borderWidth: 1,
                                    },
                                ],
                            },
                            options: {
                                responsive: true,
                                scales: {
                                    x: {
                                        title: {
                                            display: true,
                                            text: "Gaelic Proficency",
                                        },
                                    },
                                    y: {
                                        beginAtZero: true,
                                        ticks: {
                                            stepSize: 1,
                                            callback: function (value) {
                                                return Number.isInteger(value)
                                                    ? value
                                                    : null;
                                            },
                                        },
                                        title: {
                                            display: true,
                                            text: "Number of Users",
                                        },
                                    },
                                },
                            },
                        });
                    }
                });
            }
        }
    }, [isProficencyChartVisible, ageChartDataByEvent]);

    
    
    

    const fetchCommentReports = async () => {
        try {
            const response = await fetch(`${BASE_URL}/api/get_comment_reports/`);
            if (response.ok) {
                const data = await response.json();
                setCommentReports(data);
            } else {
                console.error('Failed to fetch Comment reports');
            }
        } catch (error) {
            console.error('Error fetching event reports:', error);
        }
    };

    return(
        <>
        <div className="admin-header mb-2">
            <h2> Admin </h2>
            <button className= "close-x" type = "button" onClick={onClose}>&times;</button> 
        </div>

        <div className="Admin-container">
            <div className="Admin-sidebar">
                <div 
                    className={`Admin-sidebar-item ${activeTab === "home" ? "active" : ""}`}
                    onClick={() => setActiveTab("home")}
                >
                Home
                </div>

                <div 
                    className={`Admin-sidebar-item ${activeTab === "commentReports" ? "active" : ""}`}
                    onClick={() => setActiveTab("commentReports")}
                >
                Comment Reports
                </div>

                <div 
                    className={`Admin-sidebar-item ${activeTab === "superuserRequests" ? "active" : ""}`}
                    onClick={() => setActiveTab("superuserRequests")}
                >
                Superuser Request
                </div>

                <div 
                    className={`Admin-sidebar-item ${activeTab === "userReports" ? "active" : ""}`}
                    onClick={() => setActiveTab("userReports")}
                >
                User reports
                </div>

                <div 
                    className={`Admin-sidebar-item ${activeTab === "eventReports" ? "active" : ""}`}
                    onClick={() => setActiveTab("eventReports")}
                >
                Event reports
                </div>

                <div 
                    className={`Admin-sidebar-item ${activeTab === "locationReports" ? "active" : ""}`}
                    onClick={() => setActiveTab("locationReports")}
                >
                Location reports
                </div>

                <div 
                    className={`Admin-sidebar-item ${activeTab === "pastEvents" ? "active" : ""}`}
                    onClick={() => setActiveTab("pastEvents")}
                >
                Past Events
                </div>

                <div 
                    className={`Admin-sidebar-item ${activeTab === "userInsights" ? "active" : ""}`}
                    onClick={() => setActiveTab("userInsights")}
                >
                User Insights
                </div>
            </div>

            <div className="Admin-content">
                {activeTab === "home" && (
                    <>
                    <h1>Home</h1>

                    <h3>Number of User Reports: {numOfUserReports}</h3>
                    <h3>Number of Superuser Requests: {numOfSuperuserRequests}</h3>
                    <h3>Number of Event Reports: {numOfEventReports}</h3>
                    <h3>Number of Comment Reports: {numOfCommentReports}</h3>
                    <h3>Number of Location Reports: {numOfLocationReports}</h3>
                    </>
                )}
            

                {activeTab === "superuserRequests" && (
                    <>
                    <h1>Superuser Request</h1>
                    {superuserRequests.length > 0 ? (
                        superuserRequests.map((request, index) => (
                            <div key={index} className="user-report">
                                <h3>Title: {request.request_title}</h3>
                                <h3>Location: {request.requested_location}</h3>
                                <h3>Username: {request.requested_user}</h3>
                                <h3>Body: {request.request_body}</h3>
                                <button onClick={() => makeSuperuser(request.requested_user, request.requested_location)}>Make SuperUser</button>
                                <button onClick={() => deleteRecord(request.request_id, "superuser")}> Delete Record</button>
                            </div>
                        ))
                    ) : (
                        <p>No requests available</p>
                    )}
                    </>
                )}

                {activeTab === "userReports" && (
                    <>
                    <h1>User Reports</h1>
                    {userReports.length > 0 ? (
                        userReports.map((report, index) => (
                            <div key={index} className="user-report">
                                <button onClick={() => fetchProfileData(report.reported_user)}className="GCPillbutton">
                                    Go to {report.reported_user} profile
                                </button>
                                <h3>{report.report_title}</h3>
                                <p>{report.report_body}</p>
                                <button onClick={() => deleteRecord(report.report_id, "user")}> Delete Record</button>
                            </div>
                        ))
                    ) : (
                        <p>No reports available</p>
                    )}
                    </>
                )}


                {activeTab === "eventReports" && (
                    <>
                    <h1>Event Report</h1>
                    {eventReports.length > 0 ? (
                        eventReports.map((report, index) => (
                            <div key={index} className="user-report">
                                
                                <h1>Report title: {report.report_title} </h1> 
                                <h2>Report ID: {report.event_id}</h2>
                                <h3>Event title: {report.reported_event_title}</h3>
                                <p> Report issue: {report.report_body}</p>
                                <button onClick={() => fetchEventData(report.event_id)}>go to event</button>
                                <button onClick={() => deleteRecord(report.report_id, "event")}> Delete Record</button>
                            </div>
                        ))
                    ) : (
                        <p> No reports Available</p>
                    )}
                    </>
                )}

                {activeTab === "commentReports" && (
                    <>
                    <h1>Comments Reports</h1>
                    {commentReports.length > 0 ? (
                        commentReports.map((report, index) => (
                            <div key={index} className="user-report">

                                <h1> Report Title: {report.report_title}</h1>
                                <h2> Report ID: {report.report_id}</h2>
                                <p> Report Issue: {report.report_body}</p>
                                <button onClick={() => fetchEventData(report.event_id)}>go to event</button>
                                <button onClick={() => deleteRecord(report.report_id, "comment")}> Delete Record</button>
                            </div>
                        ))
                    ) : (
                        <p>No Reports Available</p>
                    )}
                    </>
                )}

                {activeTab === "locationReports" && (
                    <>
                    <h1>Location Report</h1>
                    {locationReports.length > 0 ? (
                        locationReports.map((report, index) => (
                            <div key={index} className="user-report">
                                
                                <h1>Report title: {report.report_title} </h1> 
                                <h2>report ID: {report.report_id}</h2>
                                <h3>Location Name: {report.location_name}</h3>
                                <p> Report issue: {report.report_body}</p>
                                <button onClick={() => fetchLocationData(report.location_name)}>go to Location</button>
                                <button onClick={() => deleteRecord(report.report_id, "location")}> Delete Record</button>
                            </div>
                        ))
                    ) : (
                        <p> No reports Available</p>
                    )}
                    </>
                )}

                {activeTab === "pastEvents" && (
                    <>
                        <h1>Past Events</h1>
                        {pastEvents.length > 0 ? (
                            pastEvents.map((event, index) => {

                                const toggleComments = (eventId) => {
                                    setShowComments((prevState) => ({
                                        ...prevState,
                                        [eventId]: !prevState[eventId],
                                    }));
                                };

                                return (
                                    <div key={index} className="user-report">
                                        <h1>Event title: {event.event_title} </h1>
                                        <h1>Event Description: {event.description}</h1>
                                        <h1>Start Date: {event.start_date}</h1>
                                        <h1>End Date: {event.end_date}</h1>
                                        <h1>Number of Check-ins: {event.check_ins}</h1>

                                        <div>
                                        <button onClick={toggleAgeChartVisibility}>
                                            {isAgeChartVisible ? "Hide Chart" : "Show Age Range Chart"}
                                        </button>

                                        {isAgeChartVisible && (
                                            <div>
                                                <canvas id={`ageRangeChart-${event.event_id}`} width="400" height="200"></canvas>
                                            </div>
                                        )}
                                        </div>

                                        <div>
                                        <button onClick={toggleProficencyChartVisibility}>
                                            {isProficencyChartVisible ? "Hide Chart" : "Show Gaelic Proficency Chart"}
                                        </button>

                                        {isProficencyChartVisible && (
                                            <div>
                                                <canvas id={`proficencyRangeChart-${event.event_id}`} width="400" height="200"></canvas>
                                            </div>
                                        )}
                                        </div>

                                        <div>
                                        <button onClick={togglePostcodeVisibility}>
                                            {isPostcodeVisible ? "Hide Postcodes" : "Show Postcodes"}
                                        </button>

                                        {isPostcodeVisible && (
                                            <div>
                                                <ul>
                                                    {event.post.post.length > 0 ? (
                                                        event.post.post.map((postcode, i) => (
                                                            <li key={i}>{postcode}</li>
                                                        ))
                                                    ) : (
                                                        <li>No postcodes available for this event.</li>
                                                    )}
                                                </ul>
                                            </div>
                                        )}
                                        </div>

                                        <div>
                                        <button onClick={toggleLabelVisibility}>
                                            {isLabelVisible ? "Hide Labels" : "Show Labels"}
                                        </button>

                                        {isLabelVisible && (
                                            <div>
                                                <ul>
                                                    {event.label.label.length > 0 ? (
                                                        event.label.label.map((postcode, i) => (
                                                            <li key={i}>{postcode}</li>
                                                        ))
                                                    ) : (
                                                        <li>No Labels available for this event</li>
                                                    )}
                                                </ul>
                                            </div>
                                        )}
                                        </div>

                                        <h1>Number of Likes: {event.likes}</h1>
                                        <h1>Number of comments: {event.comments.length}</h1>
                                        <button onClick={() => toggleComments(event.event_id)}>
                                            {showComments[event.event_id] ? "Hide Comments" : "View Comments"}
                                        </button>
                                        {showComments[event.event_id] && (
                                            <div className="comments-section">
                                                {event.comments.length > 0 ? (
                                                    event.comments.map((comment, commentIndex) => (
                                                        <div key={commentIndex} className="comment">
                                                            <p><strong>Author:</strong> {comment.author}</p>
                                                            <p><strong>Date:</strong> {comment.date_created}</p>
                                                            <p><strong>Content:</strong> {comment.content}</p>
                                                            <p><strong>Likes:</strong> {comment.likes}</p>
                                                            <p><strong>Reports:</strong> {comment.reports}</p>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <p>No comments available for this event.</p>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                );
                            })
                        ) : (
                            <p>No events available.</p>
                        )}
                    </>
                )}

                {activeTab === "userInsights" && (
                <div>
                    <canvas id="scoreChart" width="400" height="200"></canvas>
                </div>
                )}

            </div>
        </div>


    {isOtherProfileVisible && (
        <div className="signup-form-container active">
        <OtherProfileForm
            otherProfileData={otherProfileData}
            user={user}
            onClose={() => setIsOtherProfileVisible(false)}
        />
    </div>
    )}

    {isEventCardVisible && (
        <div className="event-card">
        <SingleEventForm
            event_data = {eventData}
            onClose = {() => setIsEventCardVisible(false)}
        />
        </div>
    )}

    {isLocationCardVisible && (
        <div className="event-card">
        <SingleLocationForm
            location_data = {locationData}
            onClose = {() => setIsLocationCardVisible(false)}
        />
        </div>
    )}
        
</>
    )
}

export default AdminForm;